import React, { Component } from 'react';
import logo from './sla_logo.svg';
import Quote from '../Quote/Quote';
import { Link } from 'react-router-dom';

class Masthead extends Component {
  render() {
    return (
        <div className="container masthead-outer">
            <section className="masthead row" role="banner">
                <div className="col-sm-6 logo-container">
                    <Link to="/" aria-label="SLA home page"><img src={logo} className="brand-logo" alt="SLA Service Management" /></Link>
                </div>
                <Quote />
            </section>
        </div>
    );
  }
}

export default Masthead;



// WEBPACK FOOTER //
// ./src/components/Masthead/Masthead.js